/**
 * useAppT — traducteur des écrans de l'app connectée que `dashboard.json`
 * ne couvrait pas : le bureau, les paramètres, l'envoi de document, les
 * modales de quota, l'historique des crédits, et le châssis (barre
 * latérale, tiroir mobile).
 *
 * Pourquoi un second dictionnaire plutôt qu'une extension de
 * `dashboard.json` : celui-ci décrit la PAGE DOSSIER et ses sections, et
 * il est déjà chargé par une vingtaine de composants qui n'ont que faire
 * des libellés des Paramètres. `app.json` porte le reste. Même fabrique
 * (`createT`), même repli français, même syntaxe de chemins pointés — il
 * n'y a rien de nouveau à apprendre pour passer de l'un à l'autre.
 *
 * Sans argument, il lit la langue courante de l'app. Avec un argument, il
 * la reçoit — c'est ce dont ont besoin les composants qui tiennent déjà
 * une langue en prop et ne doivent pas s'abonner une seconde fois.
 */
import { useMemo } from 'react';
import app from '../i18n/app.json';
import { createT } from '../i18n/createT';
import { useAppLanguage } from './useAppLanguage';

export function useAppT(language) {
  const [current] = useAppLanguage();
  const lang = language || current;
  return useMemo(() => createT(app, lang), [lang]);
}

export default useAppT;
